const ROOT = 'communities-welcome-onboarding' as const

export function createWelcomeSetupQueryKey(locationId?: string, groupId?: string): readonly unknown[] {
  return [ROOT, 'setup', locationId, groupId] as const
}

export function createMemberOnboardingQueryKey(locationId?: string, groupId?: string): readonly unknown[] {
  return [ROOT, 'member', locationId, groupId] as const
}

export const welcomeOnboardingQueryKeys = {
  setup: createWelcomeSetupQueryKey,
  member: createMemberOnboardingQueryKey,
  all: (locationId?: string, groupId?: string) => [ROOT, locationId, groupId] as const,
} as const
